<div class="borderBox" [ngStyle]="borderStyle">
    <button [ngStyle]="buttonStyle" [disabled]="disabled" (click)="click()">
        <ng-content></ng-content>
    </button>
</div>
